import { AuthCheckUser } from '../../Utils/AuthCheck/UserCheck.auth';
import EntityLoader from '../../Components/LoadingPages/LoadingEntity.component';
import HelemtHelper from '../../Components/PageHelmet/HelmetHelper.component';
import React, { Suspense } from 'react';
import AllCourses from '../UserCourses/AllCourses.component';
import Auth from '../../Helpers/auth';
import { useQuery } from '@tanstack/react-query';
import PageScroller from '../../Components/PageScroller/PageScroller.component';
import { httpGetUser } from '../../Hooks/user/user.get.hooks';
import { CourseContainer } from './UserHomeStyles.styles';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import ErrorMessage from '../../Components/ErrorPage/Error.component';

const AllCoursesPage = () => {
  const { data } = Auth.getProfile();
  const userId = data?.id || localStorage.getItem('temp_id');
  const {
    data: user,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['user', userId],
    queryFn: () => httpGetUser(userId),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
  if (isLoading) {
    return <EntityLoader />;
  }

  if (isError) {
    return <ErrorMessage message="There was an error getting your data" />;
  }
  return (
    <AuthCheckUser>
      <CourseContainer>
        <HelemtHelper
          title="All Courses"
          description="All courses for a user account"
        />
        <Suspense fallback={<EntityLoader />}>
          <BreadCrumbs
            one="My Dashboard"
            oneLink={`/user`}
            two="Your courses"
          />
          <h2>Your courses</h2>
          <AllCourses courses={user?.courses} data={data} />
        </Suspense>
        <PageScroller />
      </CourseContainer>
    </AuthCheckUser>
  );
};

export default AllCoursesPage;
